import React from 'react'

export const DangerIcon = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.1284 7.40348L36.2431 28.4287C36.5097 29.0563 36.6263 29.5666 36.6597 30.0967C36.7263 31.3353 36.293 32.5393 35.4432 33.4658C34.5933 34.3889 33.4435 34.9339 32.1937 35H7.79785C7.28127 34.9686 6.76469 34.8514 6.28144 34.6697C3.86518 33.6953 2.69871 30.9538 3.68187 28.5773L15.8798 7.38862C16.2964 6.6438 16.9296 6.00136 17.7128 5.58849C19.9791 4.3317 22.862 5.15745 24.1284 7.40348ZM21.4455 21.2595C21.4455 22.0523 20.7957 22.7145 19.9958 22.7145C19.1959 22.7145 18.5294 22.0523 18.5294 21.2595V16.5875C18.5294 15.7931 19.1959 15.1507 19.9958 15.1507C20.7957 15.1507 21.4455 15.7931 21.4455 16.5875V21.2595ZM19.9958 28.3626C19.1959 28.3626 18.5294 27.7004 18.5294 26.9093C18.5294 26.1149 19.1959 25.4543 19.9958 25.4543C20.7957 25.4543 21.4455 26.1001 21.4455 26.8911C21.4455 27.7004 20.7957 28.3626 19.9958 28.3626Z"
        fill="#FF0307"
      />
    </svg>
  )
}
